import { CepManagedModelType } from "@hightouch/lib/cep/managed-models/shared-types";

import { ChannelType } from "src/types/cep";

export { CepManagedModelType };

export enum MessageEventGroup {
  EmailReceived = "Received an email",
  EmailInteraction = "Interacted with an email",
  SmsReceived = "Received an SMS",
  SmsInteraction = "Interacted with an SMS",
  WhatsappReceived = "Received a WhatsApp message",
  WhatsappInteraction = "Interacted with a WhatsApp message",
  PushReceived = "Received a push notification",
  PushInteraction = "Interacted with a push notification",
  SubscriptionChange = "Subscription change",
  Failures = "Failures",
}

export type MessageEventFilterConfig = {
  label: string;
  eventType: CepManagedModelType;
  funnelType?: CepManagedModelType;
  didPerformFunnel?: boolean;
};

export const MESSAGE_EVENT_FILTER_CONFIGS: Record<
  ChannelType,
  Partial<Record<MessageEventGroup, MessageEventFilterConfig[]>>
> = {
  [ChannelType.Email]: {
    [MessageEventGroup.EmailReceived]: [
      { label: "Received", eventType: CepManagedModelType.EmailReceived },
      {
        label: "Received, then didn't open",
        eventType: CepManagedModelType.EmailReceived,
        funnelType: CepManagedModelType.EmailOpened,
        didPerformFunnel: false,
      },
      {
        label: "Received, then didn't click",
        eventType: CepManagedModelType.EmailReceived,
        funnelType: CepManagedModelType.EmailClicked,
        didPerformFunnel: false,
      },
      {
        label: "Received, then unsubscribed",
        eventType: CepManagedModelType.EmailReceived,
        funnelType: CepManagedModelType.EmailUnsubscribed,
        didPerformFunnel: true,
      },
      {
        label: "Received, then marked spam",
        eventType: CepManagedModelType.EmailReceived,
        funnelType: CepManagedModelType.EmailMarkedSpam,
        didPerformFunnel: true,
      },
    ],
    [MessageEventGroup.EmailInteraction]: [
      { label: "Opened", eventType: CepManagedModelType.EmailOpened },
      { label: "Clicked", eventType: CepManagedModelType.EmailClicked },
    ],
    [MessageEventGroup.SubscriptionChange]: [
      {
        label: "Unsubscribed",
        eventType: CepManagedModelType.EmailUnsubscribed,
      },
      { label: "Subscribed", eventType: CepManagedModelType.EmailSubscribed },
    ],
    [MessageEventGroup.Failures]: [
      { label: "Bounced", eventType: CepManagedModelType.EmailBounced },
      {
        label: "Marked as spam",
        eventType: CepManagedModelType.EmailMarkedSpam,
      },
    ],
  },
  [ChannelType.Sms]: {
    [MessageEventGroup.SmsReceived]: [
      { label: "Received", eventType: CepManagedModelType.SmsReceived },
      {
        label: "Received, then didn't click",
        eventType: CepManagedModelType.SmsReceived,
        funnelType: CepManagedModelType.SmsClicked,
        didPerformFunnel: false,
      },
      {
        label: "Received, then unsubscribed",
        eventType: CepManagedModelType.SmsReceived,
        funnelType: CepManagedModelType.SmsUnsubscribed,
        didPerformFunnel: true,
      },
    ],
    [MessageEventGroup.SmsInteraction]: [
      { label: "Clicked", eventType: CepManagedModelType.SmsClicked },
    ],
    [MessageEventGroup.SubscriptionChange]: [
      {
        label: "Unsubscribed",
        eventType: CepManagedModelType.SmsUnsubscribed,
      },
      { label: "Subscribed", eventType: CepManagedModelType.SmsSubscribed },
    ],
  },
  [ChannelType.Whatsapp]: {
    [MessageEventGroup.WhatsappReceived]: [
      { label: "Received", eventType: CepManagedModelType.WhatsappReceived },
      {
        label: "Received, then didn't click",
        eventType: CepManagedModelType.WhatsappReceived,
        funnelType: CepManagedModelType.WhatsappClicked,
        didPerformFunnel: false,
      },
      {
        label: "Received, then unsubscribed",
        eventType: CepManagedModelType.WhatsappReceived,
        funnelType: CepManagedModelType.WhatsappUnsubscribed,
        didPerformFunnel: true,
      },
    ],
    [MessageEventGroup.WhatsappInteraction]: [
      { label: "Clicked", eventType: CepManagedModelType.WhatsappClicked },
    ],
    [MessageEventGroup.SubscriptionChange]: [
      {
        label: "Unsubscribed",
        eventType: CepManagedModelType.WhatsappUnsubscribed,
      },
      {
        label: "Subscribed",
        eventType: CepManagedModelType.WhatsappSubscribed,
      },
    ],
  },
  [ChannelType.Push]: {
    [MessageEventGroup.PushReceived]: [
      { label: "Received", eventType: CepManagedModelType.PushReceived },
      {
        label: "Received, then didn't open",
        eventType: CepManagedModelType.PushReceived,
        funnelType: CepManagedModelType.PushOpened,
        didPerformFunnel: false,
      },
      {
        label: "Received, then unsubscribed",
        eventType: CepManagedModelType.PushReceived,
        funnelType: CepManagedModelType.PushUnsubscribed,
        didPerformFunnel: true,
      },
    ],
    [MessageEventGroup.PushInteraction]: [
      { label: "Opened", eventType: CepManagedModelType.PushOpened },
    ],
    [MessageEventGroup.SubscriptionChange]: [
      {
        label: "Unsubscribed",
        eventType: CepManagedModelType.PushUnsubscribed,
      },
      { label: "Subscribed", eventType: CepManagedModelType.PushSubscribed },
    ],
  },
  // in_app has no message event filters yet.
  [ChannelType.InApp]: {},
};

export const CEP_CONTROL_PLANE_COLUMNS = new Set(["message_id", "topic_id"]);
